import { ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { PageHero } from '../components/PageHero'

export const pricingStages = [
  {
    title: 'Free Case Review', price: 'Free', unit: 'No obligation to continue',
    details: [
      'Discuss your care needs and potential doctor options.',
      'Initial discussion and doctor options based on field, hospital setting and availability. No clinical advice at this stage.',
      'No payment required.',
    ],
  },
  {
    title: 'Specialist Consultation', price: 'USD 200', unit: 'Per remote consultation',
    details: [
      'Speak directly with your chosen doctor about a proposed treatment plan or next steps.',
      'Doctor’s consultation fee, translation of all necessary medical records and live interpretation. No extra fees for this session.',
      'China Care.',
    ],
  },
  {
    title: 'Treatment in China', price: 'Individual quote', unit: 'Coordination and medical costs listed separately',
    details: [
      'Coordinate your confirmed treatment journey and practical support in China.',
      'China Care provides a written, itemised list of services and prices. The hospital charges separately for medical care and provides a clear, itemised bill.',
      'China Care for agreed coordination services; the treating hospital or licensed institution directly for medical care.',
    ],
  },
]

const rows = ['Purpose', 'Included services', 'Who you pay']

export function Pricing() {
  return <>
    <PageHero eyebrow="Consultation and fees" title="Specialist consultation and fees." text="Start for free. Specialist consultations cost USD 200 each. Treatment in China is quoted individually." />
    <section className="fee-comparison section-pad" aria-label="Compare the three service stages">
      <table className="fee-table">
        <caption className="fee-caption">Fees, included services and payment arrangements across the three stages</caption>
        <thead><tr><td className="fee-table-label">Your care journey</td>{pricingStages.map((stage, index) => <th scope="col" key={stage.title}>
          <span className="eyebrow">Stage 0{index + 1}</span><h2>{stage.title}</h2><p className="fee-price">{stage.price}</p><p className="fee-unit">{stage.unit}</p>
        </th>)}</tr></thead>
        <tbody>{rows.map((label, row) => <tr key={label}><th scope="row">{label}</th>{pricingStages.map(stage => <td key={stage.title}>{stage.details[row]}</td>)}</tr>)}</tbody>
      </table>
      <div className="fee-mobile">{pricingStages.map((stage, index) => <article className="fee-stage" key={stage.title}>
        <header><p className="eyebrow">Stage 0{index + 1}</p><h2>{stage.title}</h2><p className="fee-price">{stage.price}</p><p className="fee-unit">{stage.unit}</p></header>
        <dl>{rows.map((label, row) => <div key={label}><dt>{label}</dt><dd>{stage.details[row]}</dd></div>)}</dl>
      </article>)}</div>
      <Link className="text-link fee-process-link" to="/how-it-works">See the process, step by step <ArrowRight size={17} /></Link>
      <p><Link to="/treatment-in-china-costs">Build a budget for treatment in China</Link></p>
    </section>
    <section className="fee-notes section-pad" aria-label="Payment and booking notes">
      <article><h2>Before you pay</h2><p>Each payee and any deposit are identified in writing. Hospital medical charges are paid directly to the treating institution, never to a doctor’s personal account.</p></article>
      <article id="refunds"><h2>Changes & cancellations</h2><p>Cancellation and rescheduling terms, including when preparation starts and any non-refundable portion, are confirmed before booking. Hospital refunds follow the treating institution’s rules.</p></article>
      <article><h2>Additional sessions & services</h2><p>A consultation with another doctor or a follow-up is a new session at USD 200. Multidisciplinary consultations are quoted separately. Added coordination services require your approval.</p></article>
    </section>
  </>
}
